import { gql } from "@apollo/client";

export const GET_ALL_TIPO_CAPACITACION = gql`
query GetAllTipoCapacitacion($idTipoProfesional: Int!) {
    allTipoCapacitacion(idTipoProfesional: $idTipoProfesional){
            idTipoCapacitacion,
            idTipoProfesional,
            nombre,
            activo
      }
}`;